import React, { Fragment } from 'react'

import { Link as RouterLink } from 'react-router-dom'

import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'

import CardContent from '@material-ui/core/CardContent'

import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import { makeStyles } from '@material-ui/core/styles'

import Sponsors from '../footer/Sponsors'

import headerImage from '../../assets/images/header-image.png'

import { origins } from '../../constants'
import {
  variantDisplayName,
  variantDisplayNameArticle,
  variantLandingPageUrl,
} from '../../variant'

import { useApplicationVariantKey } from '../hooks/useApplicationVariants'

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(0, 2),
  },
  content: {
    width: 'auto',
  },
  cardMedia: {
    width: '100%',
  },
  actionCard: {
    height: '100%',
    transform: 'scale(1)',
    transition: ['transform'],
    transitionDuration: 300,
    '&:hover': {
      transform: 'scale(1.04)',
    },
  },
  actionCardDisabled: {
    '&:hover': {
      transform: 'scale(1)',
    },
  },
  actionCardArea: {
    height: '100%',
    padding: '0 !important',
  },
  actionLink: {
    display: 'flex',
    height: '100%',
  },
  actionBox: {
    alignItems: 'stretch',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  actionBoxHeader: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: theme.spacing(8),
    justifyContent: 'center',
  },
  actionBoxTextDisabled: {
    color: theme.palette.text.disabled,
  },
  actionBoxDivider: {
    backgroundColor: theme.palette.primary.main,
    height: 2,
    margin: theme.spacing(0, 2),
  },
  actionBoxDividerDisabled: {
    backgroundColor: theme.palette.text.disabled,
  },
  actionBoxBody: {
    alignItems: 'start',
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  backButtonContainer: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    marginTop: theme.spacing(6),
  },
  backButton: {
    color: '#ffffff',
    textDecoration: 'underline',
  },
  container: {
    [theme.breakpoints.down('xs')]: {
      width: 360,
    },
  },
})
const useStyles = makeStyles(styles)

export default function GreetingsScreen() {
  const classes = useStyles()

  const registrationProject = useApplicationVariantKey(
    origins.projectOriginIdentifier,
    'isRegistrationOpen',
  )

  return (
    <Grid className={classes.root} container>
      <Grid item xs={12}>
        <Grid container justify="center">
          <Grid item sm={12} lg={9} xl={6} className={classes.container}>
            <Card>
              <img
                alt="Header"
                className={classes.cardMedia}
                src={headerImage}
              />

              <CardContent>
                <Typography gutterBottom paragraph>
                  <b>PRÊMIO EMPREENDEDORA CURITIBANA 2023</b>
                </Typography>
                <Typography gutterBottom paragraph>
                  O talento de nossas empreendedoras é reconhecido pelo Prêmio
                  Empreendedora Curitibana, organizado pela Agência Curitiba de
                  Desenvolvimento e Inovação para valorizar mulheres
                  empreendedoras de Curitiba e da Região Metropolitana que se
                  destacam em diferentes áreas de negócio, reforçando a
                  importância do seu papel na economia da comunidade e
                  inspirando novos negócios, impulsionando o Empreendedorismo
                  feminino e a economia local.
                </Typography>
                <Typography gutterBottom paragraph>
                  Esse Prêmio é para você Mulher (cisgênero e transgênero) com
                  idade superior a 16 (dezesseis) anos, desde que emancipada;
                  pessoa física ou jurídica residente ou que possua domicílio
                  fiscal (em caso de pessoa jurídica) em Curitiba ou na Região
                  Metropolitana de Curitiba, pode concorrer em uma das cinco
                  categorias do Prêmio: Ideia Empreendedora, MEI, Pequena
                  Empresa, Startup e Iniciativa de Impacto Socioambiental.
                </Typography>
                <Typography gutterBottom paragraph>
                  As inscrições foram prorrogadas até dia 16/07/23, então se
                  você possui endereço fiscal em Curitiba ou em uma das cidades
                  da Região Metropolitana e tem interesse em concorrer à
                  premiação, leia o Edital de Seleção e faça sua inscrição.
                </Typography>
                <Typography gutterBottom paragraph>
                  <ul>
                    <li>
                      Você poderá preencher este formulário por etapas. Quando
                      iniciar seu preenchimento, você receberá no e-mail um link
                      que permite continuar sua inscrição de onde parou. Mas
                      muita atenção, pois seus dados só são salvos quando você
                      clica em salvar/continuar.{' '}
                    </li>
                    <li>
                      Na sua inscrição você deverá responder em formato de texto
                      algumas perguntas e deverá gravar um áudio dentro desta
                      mesma plataforma. Clique aqui para ver como funciona.{' '}
                    </li>
                    <li>
                      As respostas possuem número de caracteres limitados, fique
                      atenta para não ter o seu texto cortado;
                    </li>
                    <li>
                      Abaixo estão disponibilizadas todas as perguntas que
                      contém no formulário. Sugerimos que você as responda em um
                      rascunho antes de começar o preenchimento aqui na
                      plataforma.{' '}
                    </li>
                    <li>
                      {' '}
                      Mais informações sobre o Prêmio você confere no
                      regulamento.{' '}
                    </li>
                  </ul>
                </Typography>
                <Typography gutterBottom paragraph>
                  <a
                    href="https://docs.google.com/document/d/1mjtb6RrV-WVHpDCuhk5xJ0sOMyNAZ9HFZurjHQtUs3g/edit?usp=sharing"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    Clique aqui e baixe todas as perguntas que compõem este
                    formulário de inscrição.
                  </a>
                </Typography>
                <Typography
                  gutterBottom
                  paragraph
                  style={{ overflowWrap: 'break-word' }}
                >
                  Precisa de ajuda? Ficaremos felizes em auxiliá-la! <br />
                  Envie e-mail para
                  premioempreendedoracuritibana@valedopinhao.com.br
                </Typography>
                <Button
                  color="primary"
                  component={RouterLink}
                  disabled={!registrationProject}
                  to="/projeto/cadastro"
                  variant="contained"
                >
                  {registrationProject
                    ? 'Quero fazer minha inscrição'
                    : 'Inscrições encerradas'}
                </Button>
                <br /> <br />
                <Divider />
                <br />
                <Sponsors firstPage />
                {!!variantLandingPageUrl && (
                  <Fragment>
                    <br />
                    <br />

                    <Typography
                      align="center"
                      className={classes.heading}
                      component="h2"
                      gutterBottom
                      paragraph
                      variant="h6"
                    >
                      Saiba mais sobre {variantDisplayNameArticle}{' '}
                      {variantDisplayName}:{' '}
                      <Link href={variantLandingPageUrl}>
                        {variantLandingPageUrl}
                      </Link>
                    </Typography>
                  </Fragment>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
